import { c as _c } from "react/compiler-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import { useQueryClient } from "@tanstack/react-query";
import Image from "next/image";
import { useRef, useState } from "react";
import iconAddPhoto from "public/img/icon_add_a_photo.png";
import iconError from "public/img/picto-error-red.svg";
import { Photo } from "react-photo-album";
import { MAX_FILE_SIZE_LABEL } from "@/constants/upload";
import { usePhotoDelete } from "../hooks/use-photo-delete";
import { usePhotoUpload } from "../hooks/use-photo-upload";
import iconDelete from "public/img/delete.svg";
interface EmptyPhotoUploadProps {
  disabled: boolean;
  photoNumber: number;
  isEmpty?: boolean;
  photo?: Photo & {
    id: string;
  };
  club: {
    slug: string;
  };
  setIsEditing: (isEditing: boolean) => void;
  setIsDeletePending: (isDeletePending: boolean) => void;
  setPhotoToDelete: (photoToDelete: Photo & {
    id: string;
  }) => void;
  // setPhotosVisible: (photosVisible: Photo[]) => void;
}
export const PhotoUploader = t0 => {
  const $ = _c(36);
  const {
    disabled,
    photoNumber,
    isEmpty,
    photo,
    club,
    setIsDeletePending,
    setPhotoToDelete
  } = t0;
  const fileInputRef = useRef(null);
  const [errorCheck, setErrorCheck] = useState("");
  useQueryClient();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = file => {
      setErrorCheck("");
      if (file.size > 4194304) {
        setErrorCheck("La taille du fichier d\xE9passe 4Mo");
        return false;
      } else {
        if (file.type !== "image/png" && file.type !== "image/jpeg") {
          setErrorCheck("Le format du fichier doit \xEAtre .jpg ou .png");
          return false;
        }
      }
      return true;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isFileValid = t1;
  let t2;
  if ($[1] !== club.slug) {
    t2 = {
      clubSlug: club.slug,
      isFileValid
    };
    $[1] = club.slug;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    mutate: uploadPhoto,
    isPending,
    error: uploadError
  } = usePhotoUpload(t2);
  const {
    mutate: deletePhoto
  } = usePhotoDelete(club.slug);
  let t3;
  if ($[3] !== disabled) {
    t3 = () => {
      if (!disabled && fileInputRef.current) {
        fileInputRef.current.click();
      }
    };
    $[3] = disabled;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClick = t3;
  let t4;
  if ($[5] !== deletePhoto || $[6] !== photo || $[7] !== uploadPhoto) {
    t4 = event => {
      const files = event.target.files;
      if (files && files.length > 0) {
        if (isFileValid(files[0])) {
          if (photo) {
            deletePhoto(photo.id, {
              onSuccess: () => {
                uploadPhoto(files[0]);
              }
            });
          } else {
            uploadPhoto(files[0]);
          }
        }
      }
      event.target.value = "";
    };
    $[5] = deletePhoto;
    $[6] = photo;
    $[7] = uploadPhoto;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleFileChange = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      position: "relative"
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== photo || $[11] !== setIsDeletePending || $[12] !== setPhotoToDelete) {
    t6 = photo && <div className="absolute" style={{
      top: "5px",
      right: "5px",
      cursor: "pointer",
      border: "2px solid #9B9B9B",
      borderRadius: "50%",
      zIndex: 1000
    }} onClick={() => {
      setPhotoToDelete(photo);
      setIsDeletePending(true);
    }}><Image src={iconDelete} alt="delete" width={20} height={20} /></div>;
    $[10] = photo;
    $[11] = setIsDeletePending;
    $[12] = setPhotoToDelete;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      backgroundColor: "white"
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = `flex flex-col items-center justify-center h-full relative  ${isEmpty && disabled ? "cursor opacity-50" : "cursor-pointer"}`;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      minWidth: "150px",
      minHeight: "150px",
      border: "2px dashed #9B9B9B",
      borderRadius: "10px"
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== errorCheck || $[17] !== isEmpty || $[18] !== isPending || $[19] !== photo?.src || $[20] !== photoNumber || $[21] !== uploadError) {
    t10 = errorCheck || uploadError ? <div className="flex flex-col gap-2 justify-center items-center h-full max-h-10" style={{
      color: "#EE4540",
      fontSize: "12px",
      fontWeight: "bold",
      maxWidth: "100px"
    }}><Image src={iconError} alt="add photo" width={50} height={50} /><p>{errorCheck || uploadError?.message}</p></div> : isPending ? <div className="flex justify-center items-center h-full"><CircularProgress sx={{
        color: "#9B9B9B"
      }} /></div> : isEmpty ? <div><Image src={iconAddPhoto} alt="add photo" width={50} height={50} /><p style={{
        fontSize: "16px",
        color: "#9B9B9B",
        marginTop: "10px"
      }}>Photo {photoNumber}</p><p style={{
        fontSize: "10px",
        color: "#9B9B9B",
        marginTop: "-5px"
      }}>{MAX_FILE_SIZE_LABEL}</p></div> : <Image src={photo?.src || ""} alt="add photo" width={100} height={100} />;
    $[16] = errorCheck;
    $[17] = isEmpty;
    $[18] = isPending;
    $[19] = photo?.src;
    $[20] = photoNumber;
    $[21] = uploadError;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      display: "none"
    };
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== handleFileChange) {
    t12 = <input type="file" ref={fileInputRef} onChange={handleFileChange} accept=".png,.jpg,.jpeg" style={t11} />;
    $[24] = handleFileChange;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t8) {
    t13 = <div className={t8} style={t9}>{t10}{t12}</div>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== handleClick || $[31] !== t13) {
    t14 = <div style={t7} onClick={handleClick}>{t13}</div>;
    $[30] = handleClick;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14 || $[34] !== t6) {
    t15 = <div style={t5}>{t6}{t14}</div>;
    $[33] = t14;
    $[34] = t6;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};